'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

/* eslint-disable complexity */
/**
 * Get cookie value by name factory.
 * @param {String} cookies raw cookies
 * @returns {Function} function that returns value for passed cookie name.
 *
 */
exports.default = function (cookies) {
    return function (name) {
        var cookieArr = cookies.split(';');
        while (cookieArr.length) {
            var cookie = cookieArr.pop();
            var separatorIndex = cookie.indexOf('=');
            separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;
            var cookieName = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
            if (cookieName === name) {
                return decodeURIComponent(cookie.slice(separatorIndex + 1));
            }
        }
        return null;
    };
};
//# sourceMappingURL=getCookie.js.map